import { render, staticRenderFns } from "./CallSttResults.vue?vue&type=template&id=3646859a&scoped=true&"
import script from "./CallSttResults.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CallSttResults.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CallSttResults.vue?vue&type=style&index=0&id=3646859a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3646859a",
  null
  
)

export default component.exports